(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-event-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // HYBRID TELEPORT: MOVE TO ANCHOR IF EXISTS
  const wrapper = document.getElementById('GlobalEventSliderWrapper');
  const anchor = document.getElementById('event-slider-anchor');
  
  if (wrapper && anchor) {
    // If we found an anchor, move the slider there and ensure it's visible
    anchor.appendChild(wrapper);
    wrapper.style.display = 'block';
  }
  
  if (!wrapper) return;

  // --- SLIDER NAV ---
  const slider = wrapper.querySelector('.event-slides');
  const leftArrow = wrapper.querySelector('.arrow-left');
  const rightArrow = wrapper.querySelector('.arrow-right');
  if(slider && leftArrow && rightArrow) {
    leftArrow.addEventListener('click', () => {
      const card = slider.querySelector('.event-slide-item');
      if(card) slider.scrollBy({ left: -(card.offsetWidth + 20), behavior: 'smooth' });
    });
    rightArrow.addEventListener('click', () => {
      const card = slider.querySelector('.event-slide-item');
      if(card) slider.scrollBy({ left: (card.offsetWidth + 20), behavior: 'smooth' });
    });
  }
  
  // --- ADD TO CART ---
  const atcButtons = wrapper.querySelectorAll('.js-add-bundle');
  atcButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantString = btn.dataset.variants;
      const multiplier = parseInt(btn.dataset.multiplier) || 1;
      if(!variantString) return;
      const variantIds = variantString.split(',').reverse();
      const originalText = btn.innerText;
      btn.innerText = 'Adding...';
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
      try {
        const items = variantIds.map(function (id) {
          return { id: parseInt(id), quantity: 1 * multiplier };
        });
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        btn.innerText = 'Added!';
        window.location.href = '/cart';
      } catch (error) {
        btn.innerText = 'Error';
        setTimeout(() => { btn.innerText = originalText; btn.style.opacity = '1'; btn.style.pointerEvents = 'auto'; }, 2000);
      }
    });
  });
  
  // --- TIMER & EVENT MODE ---
  const isEventEnabled = wrapper.dataset.eventMode === 'true';
  const endDateStr = wrapper.dataset.endDate;
  const timerContainer = wrapper.querySelector('.event-timer-display');
  const eventPrices = document.querySelectorAll('.event-pricing');
  const standardPrices = document.querySelectorAll('.standard-pricing');
  const textEvent = document.querySelector('.text-content-event');
  const textStandard = document.querySelector('.text-content-standard');
  const slideEventTexts = document.querySelectorAll('.slide-text-event');
  const slideStandardTexts = document.querySelectorAll('.slide-text-standard');
  const dObj = document.getElementById('days');
  const hObj = document.getElementById('hours');
  const mObj = document.getElementById('minutes');
  const sObj = document.getElementById('seconds');
  function updateState(isActive) {
    if (isActive) {
      if (timerContainer) timerContainer.classList.remove('hidden');
      if(textEvent) textEvent.classList.remove('hidden');
      if(textStandard) textStandard.classList.add('hidden');
      eventPrices.forEach(el => el.classList.remove('hidden'));
      standardPrices.forEach(el => el.classList.add('hidden'));
      slideEventTexts.forEach(el => el.classList.remove('hidden'));
      slideStandardTexts.forEach(el => el.classList.add('hidden'));
    } else {
      if (timerContainer) timerContainer.classList.add('hidden');
      if(textEvent) textEvent.classList.add('hidden');
      if(textStandard) textStandard.classList.remove('hidden');
      eventPrices.forEach(el => el.classList.add('hidden'));
      standardPrices.forEach(el => el.classList.remove('hidden'));
      slideEventTexts.forEach(el => el.classList.add('hidden'));
      slideStandardTexts.forEach(el => el.classList.remove('hidden'));
    }
  }
  if (!isEventEnabled) { updateState(false); return; }
  const endDate = new Date(endDateStr).getTime();
  const tick = () => {
    const now = new Date().getTime();
    const distance = endDate - now;
    if (isNaN(distance) || distance < 0) { clearInterval(timerInterval); updateState(false); return; }
    updateState(true);
    dObj.innerText = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
    hObj.innerText = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
    mObj.innerText = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
    sObj.innerText = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
  };
  tick();
  const timerInterval = setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const popups = document.querySelectorAll('.popup-modal');
    
    popups.forEach(popup => {
      const sectionId = popup.dataset.sectionId;
      const storageKey = `popup_closed_${sectionId}`;
      const delay = parseInt(popup.dataset.delay) * 1000;
      const scrollPct = parseInt(popup.dataset.scroll);
      const triggerMode = popup.dataset.trigger; 
      const testMode = popup.dataset.testMode === 'true'; 
      const expiryHours = 24;
      
      if (!testMode) {
        const lastClosed = localStorage.getItem(storageKey);
        if (lastClosed) {
          const now = new Date().getTime();
          const hoursSinceClose = (now - lastClosed) / (1000 * 60 * 60);
          if (hoursSinceClose < expiryHours) {
            return; 
          }
        }
      }

      let isVisible = false;

      const showPopup = () => {
        if (isVisible) return;
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        isVisible = true;
        window.removeEventListener('scroll', checkScroll);
      };

      const closePopup = () => {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        isVisible = false;
        
        if (!testMode) {
          localStorage.setItem(storageKey, new Date().getTime());
        }
      };

      if (triggerMode === 'time' || triggerMode === 'both') {
        setTimeout(showPopup, delay);
      }

      const checkScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentCurrent = (scrollTop / docHeight) * 100;

        if (scrollPercentCurrent >= scrollPct) {
          showPopup();
        }
      };

      if (triggerMode === 'scroll' || triggerMode === 'both') {
        window.addEventListener('scroll', checkScroll, { passive: true });
      }

      popup.querySelectorAll('[data-close-popup]').forEach(el => {
        el.addEventListener('click', closePopup);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isVisible) {
          closePopup();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
